/* import __COLOCATED_TEMPLATE__ from './sub-category-row.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";

export default CategoryListItem.extend({});
